<template>
    <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
</template>

<script>
import { mapGetters } from 'vuex'
import { ApiUrl } from '@/common/api.service'
import columns from '@/views/ticket/datatable/columns'
import actions from '@/views/ticket/datatable/actions'
import { AuthorizationHeader } from '@/common/jwt.service'

export default {
    computed: {
        datatableProps() {
            return {
                withPanel: false,
                id: "user_ticket_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path('ticket'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function(res) {
                                return res.data.data
                            },
                            params: {
                                user_id: this.$route.params.hashid,
                            },
                        }
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {
                },
                pagination: false,
                sortable: true,
                columns: columns,
                actions: actions
            }
        }
    }
}
</script>

<style>

</style>